module.exports = __webpack_public_path__ + "static/img/laravel.b0ba6d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/laravel.png
// module id = A16m
// module chunks = 0